import React from 'react';

import { reverse } from 'named-urls';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

interface AuditTemplateActionCellProps {
  rowData: { uuid: string; name?: string };
}

const AuditTemplateActionCell: React.FunctionComponent<AuditTemplateActionCellProps> = ({ rowData }) => {
  const { routing } = useStore();

  const handleEdit = (): void => {
    // Keeps the legacy `templateId` param name — rename deferred to M3.4.
    routing.push(reverse(routes.dashboard.audits.templates.details, { templateId: rowData.uuid }));
  };

  // Duplication bypasses the submission-form serializer, so it skips every structural check and
  // clones the settings row. Audits do not get it; Events keep it.
  const cellActions: ActionConfig[] = [{ id: 'edit-button', label: 'Edit', onClick: handleEdit }];

  return <ActionCell actions={cellActions} recordName={rowData.name} />;
};

export default AuditTemplateActionCell;
